module.exports = __webpack_public_path__ + "img/logo8.6a3cde0f.png";